import React from "react";
import Button, { ButtonStyles } from "./Button.jsx";

import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function OffersTrafficAcquisitionStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .offers-traffic-acquisition": {
            display: "grid",
            gridGap: "20px",
            width: "100%",

            "& .item-wrapper": {
                display: "grid",
                gridAutoFlow: "column",

                [MobileBreakpoint]: {
                    gridAutoFlow: "row",
                },

                "& img": {
                    width: "500px",
                    [MobileBreakpoint]: {
                        width: "100%",
                    },
                },
            },

            "& .item": {
                display: "grid",
                gridTemplateColumns: "1fr max-content",
                gridGap: "46px",
                padding: "26px 40px",

                "& .item-text": {
                    display: "grid",
                    gridGap: "20px",
                },

                "& .item-button": {
                    alignSelf: "flex-end",
                    justifySelf: "flex-end",

                    [MobileBreakpoint]: {
                        justifySelf: "auto",
                    },
                },

                [MobileBreakpoint]: {
                    gridTemplateColumns: "1fr",
                },
            },

            "& .item.with-picture": {
                gridTemplateColumns: "auto",
            },
        },

        ...ButtonStyles(params),
    };
}

export default function OffersTrafficAcquisition(props) {
    const { BusinessGoal, Offers } = props.variables;
    const LI = useLoremIpsum();

    if (BusinessGoal !== "traffic-acquisition") {
        return null;
    }

    const _Offers = Offers || LI.Offers;
    if (!Array.isArray(Offers)) {
        console.warn("Offers is not array!");
        return null;
    }

    return (
        <div className="offers-traffic-acquisition w1200px">
            {_Offers?.map(({ title, description, button, buttonLink, picture }, index) => {
                const CNItem = ["item"];
                picture && CNItem.push("with-picture");

                return (
                    <div key={index} className="item-wrapper invert-bg">
                        {picture && <img src={picture.src} />}
                        <div className={CNItem.join(" ")}>
                            <div className="item-text">
                                <h2>{title || LI.Offers[0].title}</h2>
                                <p>{description || LI.Offers[0].description}</p>
                            </div>

                            <div className="item-button">
                                <Button
                                    className={["without-gradient", "primary"]}
                                    text={button || LI.Offers[0].goToOurStore}
                                    link={buttonLink || "#"}
                                />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
